<div class="component">
  <div class="button-go-back">
    <button class="btn-goback" (click)="goback()">Voltar</button>
  </div>
<mat-card class="mat-form-inserirPedido">
  <div class="form-pedido">
    <div class="div-forms-pedido">
      <mat-card class="example-card">
        <div>
          <label class="image-upload-container btn btn-bwm">
            <span>Selecione uma imagem</span>
            <input #imageInput
                  type="file"
                  accept="image/*">
          </label>
          <!-- <img mat-card-image src="https://material.angular.io/assets/img/examples/shiba2.jpg" alt="Photo of a Shiba Inu"> -->
        </div>
      </mat-card>

    </div>
    <div class="example-container">

    <mat-form-field appearance="fill" class="mart-card-form">
      <mat-label>Turma</mat-label>
      <input matInput [(ngModel)]="pedido.nomeCliente" placeholder="digite o nome">


    </mat-form-field>


  <br>
    <mat-form-field appearance="fill"class="mart-card-form">
      <mat-label>Telefone</mat-label>
      <input matInput [(ngModel)]="pedido.telefone" placeholder="digite o telefone">
      <mat-cell *matCellDef="let pedido">{{pedido.telefone | telefonePipe}}</mat-cell>
    </mat-form-field>

    <br>
    <mat-form-field appearance="fill"class="mart-card-form">
      <mat-label>Quantidade</mat-label>
      <input matInput [(ngModel)]="pedido.tamanho" placeholder="digite o tamanho">
    </mat-form-field>
    <br>

    <mat-form-field appearance="fill" class="mart-card-form example-full-width">
      <mat-label>Observação</mat-label>
      <input matInput [(ngModel)]="pedido.observacao" placeholder="Observação">
    </mat-form-field>
    </div>
  </div>

<div class="button-register-pedido">
  <button class="btn btn-primary" [routerLink]="['/listarpedido']">Listar Pedidos</button>
  <button class="btn btn-second" [routerLink]="['/cadastrarpedido']" (click)="inserirPedido()"  *ngIf="operacaoCadastro">Cadastrar</button>
  <button class="btn btn-second" [routerLink]="['/cadastrarpedido']" (click)="inserirPedido()"  *ngIf="!operacaoCadastro">Editar</button>

  <!-- <button mat-raised-button color="primary" [routerLink]="['/listarpedido']">Listar Pedidos</button>
  <button mat-raised-button btn btn-second [routerLink]="['/cadastrarpedido']"(click)="inserirPedido()"  *ngIf="operacaoCadastro">Cadastrar</button> -->
 <!-- <button mat-raised-button color="primary">Cadastrar Pedido</button> -->
</div>
  </mat-card>


</div>
